export const env = {
    apiUrl: import.meta.env.VITE_API_URL,
    environment: import.meta.env.VITE_APP_ENV,
    debug: import.meta.env.VITE_DEBUG === 'true',
    inscriptionApiUrl: import.meta.env.VITE_INSCRIPTION_API_URL,
    programTypes: import.meta.env.VITE_PROGRAM_TYPES,
    supportFormUrl: import.meta.env.VITE_SUPPORT_FORM_URL,
    supportWhatsAppNumber:
        import.meta.env.VITE_SUPPORT_WHATSAPP_NUMBER || '573195650616'
} as const
